import { action } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { Group } from "@shared/models/group"
import type { User } from "@shared/models/user"
import { handleError } from "cc-frontend/error-handling"
import type Dialog from "cc-frontend/services/dialog"
import type Rpc from "cc-frontend/services/rpc"

interface Sig {
  Args: {
    group: Group
    user: User
  }
}

export default class RequestedGroup extends Component<Sig> {
  @service declare dialog: Dialog
  @service declare rpc: Rpc

  @tracked isRpcInProgress = false

  @action
  cancelMembership() {
    this.dialog
      .blank("dialogs/confirm-cancel-membership-requested", {
        className: "dialog--create-annotation",
      })
      .then(() => {
        this.isRpcInProgress = true
        this.rpcToCancelMembership(this.args.group.id)
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }

  rpcToCancelMembership(groupId: string) {
    this.rpc
      .group_cancel_other_membership({
        groupId,
        membershipType: "group-membership-requested",
      })
      .then(() => {
        if (this.isDestroyed || this.isDestroying) return
        later(() => (this.isRpcInProgress = false), 250)
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Users::Home::RequestedGroup": typeof RequestedGroup
  }
}
